import React from "react";
import { ApolloProvider, gql, useQuery } from "@apollo/client";
import client from "../lib/apolloClient";
import PartnerDirectoryPage from "../components/Succeedo/PartnerDirectory/PartnerDirectoryPage";

const PARTNER_DIRECTORY_QUERY = gql`
  query PartnerDirectory {
    currentUser {
      id
      name
      succeedo_persona
      succeedo_country
      action_plan {
        open_count(source: "succeedo")
        completed_count(source: "succeedo")
      }
    }
    partners {
      id
      name
      org_name
      partner_category
      bio
      geography_regions
      industry_tags
      website_url
      contact_email
      accepts_introductions
      avatar_url
      rating
      verified
    }
  }
`;

function deriveInitials(name) {
  if (!name) return "??";
  const parts = name.trim().split(/\s+/);
  const first = parts[0] ? parts[0][0] : "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}

function PartnerDirectoryLoader({ initialRoleFilter }) {
  const { data, loading, error } = useQuery(PARTNER_DIRECTORY_QUERY);

  const user = data?.currentUser;
  const persona = (user?.succeedo_persona || "seller").toUpperCase();
  const userName = user?.name || "";
  const userInitials = deriveInitials(userName);

  const actionPlan = user?.action_plan || {};
  const openCount = actionPlan.open_count || 0;
  const completedCount = actionPlan.completed_count || 0;
  const total = Math.max(openCount + completedCount, 5);
  const planProgress = {
    completed: completedCount,
    total,
    percentage: total > 0 ? Math.round((completedCount / total) * 100) : 0,
  };

  return (
    <PartnerDirectoryPage
      partners={data?.partners || []}
      loading={loading}
      error={error || null}
      persona={persona}
      userName={userName}
      userInitials={userInitials}
      planProgress={planProgress}
      actionPlanBadge={openCount}
      initialRoleFilter={initialRoleFilter}
      country={user?.succeedo_country || 'CA'}
    />
  );
}

const SucceedoPartnerDirectoryContainer = (props, _railsContext) => (
  <ApolloProvider client={client}>
    <PartnerDirectoryLoader initialRoleFilter={props?.initialRoleFilter} />
  </ApolloProvider>
);

export default SucceedoPartnerDirectoryContainer;
